/*
 * Public API Surface of ngx-autocom-place
 */

export * from './lib/ngx-autocom-place.directive';
export * from './lib/ngx-autocom-place.module';
